module.exports = __webpack_public_path__ + "img/sy-pic7.0838340a.png";